<template>
  <div id="init-home-container" class="d-flex background_color">
    <!--//@*/*
    //    *RPD Records pages App v0.91
    //    * Copyright (c) 2023, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <!-- <auth></auth> -->

    <v-spacer></v-spacer>

    <v-main id="home-main" style="padding: 0 !important">
      <titlecard :title_text="'DFR: DRONES AS FIRST RESPONDERS'"></titlecard>
      <!-- top card with color bar -->
      <top_card :descr_text="descr_text" :welcome="'Welcome'"></top_card>

      <v-container class="background_color black--text" id="home-container">
        <template>
          <div id="big-card" class="d-flex justify-center align-center">
            <v-card
              id="home-content-area"
              class="mb-16 pt-4"
              color="white"
              elevation="4"
              outlined
            >
           
              <div
                id="contains-expansions-layout"
                class="d-flex justify-center"
              >
                <v-expansion-panels id="all-panels" accordion>
                  <!-- public request -->
                  <content1
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></content1>

                 <content2  
                  @onExpansionPanelClick="onExpansionPanelClick">  
                 </content2>
                  <content3  
                  @onExpansionPanelClick="onExpansionPanelClick">  
                 </content3>
                </v-expansion-panels>
              </div>
            </v-card>
          </div>
        </template>
      </v-container>
    </v-main>
    <v-spacer></v-spacer>
    <v-btn
      id="fabup"
      ref="fabup"
      @click.prevent="fabup"
      title="Top of page"
      class="fabup"
      elevation="2"
      fab
      color="yellow accent-2"
    >
      <v-icon color="black" dark x-large> $chevup </v-icon>
    </v-btn>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .fabup {
    position: fixed;
    left: 85%;
    top: 90%;
    z-index: 500;
  }
  .topbar {
    width: 100%;
    height: 18px;
    background-color: #708e92;
  }
  a {
    color: blue;
  }
  #all-panels {
    width: 90%;
  }
  .v-main {
    padding: 0 !important;
  }

  .theme--light.v-expansion-panels .v-expansion-panel {
    color: white;
  }

  .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
  .recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 7px !important;
  }
  .bcs-expansion-content {
    color: black;
  }
  .alice {
    color: aliceblue;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .fabup {
    position: fixed;
    left: 95%;
    top: 90%;
  }
  .basic-interior-card {
    min-height: 200px;
  }
  #init-home-container {
    width: 100%;
  }
  #home-container {
    width: 100vw;

    height: auto;
    position: relative;
    top: 0px;
  }
  #home-content-area {
    width: 100%;
    max-width: 85%;
    height: auto;
    background-color: white;
  }
  #top-card-content-area {
    width: 85%;
    background-color: white;
    height: auto;
  }
  #all-panels {
    width: 95%;
  }
}
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .set-vcard-height {
    height: 320px;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import * as easings from "vuetify/lib/services/goto/easing-patterns";
import top_card from "../components/top_card.vue";
const titlecard = () => import("./titlecard.vue");
const content1 = () => import("./content1.vue");
const content2 = () => import("./content2.vue");
const content3 = () => import("./content3.vue");
//
// import xtabs from "./xtabs.vue";
//import auth from "./auth.vue";

export default {
  name: "Home",
  components: {
    top_card,
    titlecard,
    content1,
    content2,
    content3,

  },
  mixins: [bus_common],
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {
      descr_text:
        `<p>The Reno Police Department is committed to enhancing public safety through constant innovation and forward thinking. Recently the department has expanded its capability through the responsible use of aerial technology. With a focus on safety, accountability, and transparency, the Reno Police Departments growing drone program helps improve response times to calls for service and strengthen situational awareness for officers on the ground.
Small Unmanned Aerial Systems (sUAS), commonly referred to as drones, 
provide a perspective that assists officers in responding to critical
 incidents, conducting investigations, locating missing persons, and more.</p>
 <p>Please check out: <a style="color:#4DA3FF;"
   href="https://dashboard.liveops.brincdrones.com/renopdnv"
  target="_blank" >DRF TRANSPARENCY DASHBOARD</a></p>
`,
    };
  },
  watch: {
    // "$store.state.user": function () {
    //   //keep this
    //   let self = this;
    //   this.init();
    // },
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    fabup(event) {
      const bdy = document.getElementsByClassName("bodyback")[0];
      bdy.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      document.getElementById("fabup").blur();
    },
    onExpansionPanelClick(event) {
      var targetID = event.currentTarget.id;
      var self = this;
      if (
        event.currentTarget.classList.contains(
          "v-expansion-panel-header--active"
        )
      ) {
        console.log("Panel is closing/now closed.");
      } else {
        console.log("Panel is opening/now open.");
        setTimeout(
          function () {
            //   window.scroll(0, 3500);
            console.log(targetID);
            const daWindow = document.getElementById("vapp");
            const element = document.getElementById(targetID);
            element.scrollIntoView({ behavior: "smooth" });
          },
          500,
          targetID
        );
      }
    },
    init(self) {
      this.show_loader(false);
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
